// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
// Actions
import { AffiliationActions, AffiliationActionTypes } from '../_actions/affiliation.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Affiliation } from '../_models/affiliation.model';

// tslint:disable-next-line:no-empty-interface
export interface AffiliationsState extends EntityState<Affiliation> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedAffiliationId: number;
  lastQuery: QueryParamsModel;
  error: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Affiliation> = createEntityAdapter<Affiliation>();

export const initialAffiliationsState: AffiliationsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedAffiliationId: undefined,
  showInitWaitingMessage: true,
});

export function affiliationsReducer(
  state = initialAffiliationsState,
  action: AffiliationActions,
): AffiliationsState {
  switch (action.type) {
    case AffiliationActionTypes.AffiliationsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedAffiliationId: undefined,
      };
    case AffiliationActionTypes.AffiliationsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case AffiliationActionTypes.AffiliationOnServerCreated:
      return {
        ...state,
      };
    case AffiliationActionTypes.AffiliationOnServerUpdated:
      return {
        ...state,
      };
    case AffiliationActionTypes.AffiliationStatusOnServerUpdated:
      return {
        ...state,
      };
    case AffiliationActionTypes.AffiliationsStatusOnServerUpdated:
      return {
        ...state,
      };
    case AffiliationActionTypes.AffiliationOnServerDeleted:
      return {
        ...state,
      };
    case AffiliationActionTypes.ManyAffiliationsOnServerDeleted:
      return {
        ...state,
      };
    case AffiliationActionTypes.AffiliationCreated:
      return adapter.addOne(action.payload.affiliation, {
        ...state,
        lastCreatedAffiliationId: action.payload.affiliation.id,
      });
    case AffiliationActionTypes.AffiliationUpdated:
      return adapter.updateOne(action.payload.partialAffiliation, state);
    case AffiliationActionTypes.AffiliationStatusUpdated: {
      // tslint:disable-next-line
      const _partialAffiliation: Update<Affiliation> = {
        id: action.payload.id,
        changes: {
          is_active: action.payload.is_active,
        },
      };
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      return adapter.updateOne(_partialAffiliation, state);
    }
    case AffiliationActionTypes.AffiliationsStatusUpdated: {
      // tslint:disable-next-line
      const _partialAffiliations: Update<Affiliation>[] = [];
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      for (let i = 0; i < action.payload.affiliations.length; i++) {
        _partialAffiliations.push({
          id: action.payload.affiliations[i].id,
          changes: {
            is_active: action.payload.is_active === 1 ? true : false,
          },
        });
      }
      return adapter.updateMany(_partialAffiliations, state);
    }
    case AffiliationActionTypes.AffiliationDeleted:
      return adapter.removeOne(action.payload.id, state);
    case AffiliationActionTypes.ManyAffiliationsDeleted: {
      const _ids = [];
      action.payload.ids.forEach((obj) => _ids.push(obj.id));
      return adapter.removeMany(_ids, state);
    }
    case AffiliationActionTypes.AffiliationsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case AffiliationActionTypes.AffiliationsPageLoaded: {
      return adapter.addMany(action.payload.affiliations, {
        ...initialAffiliationsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }
    case AffiliationActionTypes.ThrowError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case AffiliationActionTypes.ClearErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getAffiliationState = createFeatureSelector<AffiliationsState>('affiliations');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
